<template>
  <!-- eslint-disable -->
  <div>
    <b-row class="mb-2">
      <b-col sm="12">
        <b-button variant="danger" @click="$router.go(-1)">Atras</b-button>
      </b-col>
    </b-row>
    <b-row v-if="datosMov">
      <b-col sm="12">
        <b-card no-body header-bg-variant="dark">
          <b-card-header class="border-b-2 bg-secondary">
            <h4 class="text-white">Información de Movimiento</h4>
          </b-card-header>
          <b-card-body class="mt-2">
            <b-row>
              <b-col sm="6" lg="3" class="flex">
                <strong>Tienda Destino: </strong>
                <p class="">{{ datosMov.establishmentDestiny.name }}</p>
              </b-col>
              <b-col sm="6" lg="3" class="flex">
                <strong>Tienda Origen: </strong>
                <p class="">{{ datosMov.establishmentOrigin.name }}</p>
              </b-col>
              <b-col sm="6" lg="2" class="flex">
                <strong>Número de documento: </strong>
                <p class="">{{ datosMov.documentCode }}</p>
              </b-col>
              <b-col sm="6" lg="2" class="flex">
                <strong>Transportado por: </strong>
                <p class="">{{ datosMov.userReceiver.fullname }}</p>
              </b-col>
              <b-col
                sm="6"
                lg="2"
                class="flex"
                v-if="datosMov.internalRecords.length"
              >
                <template
                  v-if="
                    ['Observado', 'Alerta'].includes(
                      datosMov.internalRecords.at(-1).state
                    )
                  "
                >
                  <strong>Observación realizada por:</strong>
                  <p>
                    {{ datosMov.internalRecords.at(-1).userChanged.fullname }}
                  </p>
                </template>
                <template
                  v-else-if="
                    datosMov.internalRecords.at(-1).state === 'Aprobado'
                  "
                >
                  <strong>Aprobado por:</strong>
                  <p>
                    {{ datosMov.internalRecords.at(-1).userChanged.fullname }}
                  </p>
                </template>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-card no-body>
          <b-card-header class="bg-secondary border-b-2">
            <h4 class="text-white">Detalles de Movimiento</h4>
          </b-card-header>
          <b-card-text class="">
            <b-table
              class="position-relative"
              :hover="true"
              :items="details"
              responsive
              :fields="fields"
              show-empty
              empty-text="No existen"
              @sort-changed="sortChanged"
            >
            </b-table>
            <div class="mx-2 mb-2">
              <b-row>
                <b-col sm="3">
                  <b-form-group
                    label-cols="4"
                    label-cols-md="4"
                    label-size="md"
                    label="Entradas"
                    label-for="input-md"
                  >
                    <b-form-select
                      v-model="showEntrie"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="title"
                      :options="entries"
                      @change="changeSizePage"
                    />
                  </b-form-group>
                </b-col>
                <b-col sm="3" class="mt-75" style="font-size: 12px">
                  <span> {{ totalElements }} Registros en total</span>
                </b-col>
                <!-- Pagination -->
                <b-col
                  cols="12"
                  sm="6"
                  class="d-flex align-items-center justify-content-center justify-content-sm-end"
                >
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalElements"
                    :per-page="showEntrie"
                    class="mb-0 mt-1 mt-sm-0"
                    prev-class="prev-item"
                    next-class="next-item"
                    @change="cambioPagina"
                  >
                    <template #prev-text>
                      <feather-icon icon="ChevronLeftIcon" size="18" />
                    </template>
                    <template #next-text>
                      <feather-icon icon="ChevronRightIcon" size="18" />
                    </template>
                  </b-pagination>
                </b-col>
              </b-row>
            </div>
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from "vue";
import { BootstrapVue, BootstrapVueIcons, VBTooltip } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import InternalMovement from "@/services/InternalMovement";

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

export default {
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  data() {
    return {
      datosMov: null,
      details: [],
      fields: [
        {
          key: "autopart.uniqueCode",
          label: "Código Único",
          sortable: true,
        },
        {
          key: "autopart.originalCode",
          label: "Codigo Original",
          sortable: true,
        },
        { key: "autopart.alterCode", label: "Codigo Alter.", sortable: true },
        { key: "autopart.description", label: "Descripción", sortable: false },
        { key: "qty", label: "Cantidad", sortable: false },
        { key: "observation", label: "Observación", sortable: false },
      ],
      currentPage: 1,
      entries: [10, 20, 50, 100],
      showEntrie: 10,
      totalElements: 0,
      sort: "id",
      order: "desc",
    };
  },
  mounted() {
    this.getData();
    console.log("DETALLE ENTRADA");
  },
  methods: {
    async getData() {
      const resp = await InternalMovement.getMovementObservation(
        this.$route.params.id,
        this.$store
      );

      if (resp && resp.data) {
        console.log("RESPUESTA", resp.data);
        this.datosMov = resp.data.internalMovement;
        this.details = resp.data.internalDetail;
        console.log("MOVS", this.datosMov);
        console.log("DETAIL", this.details);
        this.totalElements = this.details.length;
      } else {
        console.error("Error: Datos no encontrados.");
      }
    },

    cambioPagina(e) {
      this.currentPage = e;
    },
    changeSizePage() {},
    sortChanged(data) {
      this.sort = data.sortBy;
      this.order = data.sortDesc ? "desc" : "asc";
    },
    back() {
      this.$router.push("/inventario/entrada/bandeja");
    },
  },
};
</script>

<style></style>
